import { render, staticRenderFns } from "./GeneralPopup.vue?vue&type=template&id=3fba9c42&"
import script from "./GeneralPopup.vue?vue&type=script&lang=js&"
export * from "./GeneralPopup.vue?vue&type=script&lang=js&"
import style0 from "./GeneralPopup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports